<template>
  <div class="title_bar">
    <div class="left">
      <div class="title">
        {{ title }}
        <slot name="hint"></slot>
      </div>
      <div v-if="tip" class="tip">
        {{ tip }}
      </div>
    </div>
    <div class="right">
      <slot name="btns"></slot>
      <el-button
        round
        @click="helpDocClick(introduction.link, introduction)"
      >
        <span class="icon">
          <InstructionsIcon width="15" height="15" viewBox="0 0 32 32" class="instructions" />
        </span>
        {{ $t("General.Instructions") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { helpDocClick } from '@/js/utils/handleGA.js'
import InstructionsIcon from '@/assets/img/common/eva-question-mark-circle-fill.svg?inline'

export default {
  components: {
    InstructionsIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    introduction: {
      type: Object,
      default: null
    },
    tip: {
      type: String,
      default: null
    }
  },
  methods: {
    helpDocClick
  }
}
</script>

<style lang="scss" scoped>
.title_bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 20px 0;
  &.center {
    margin: 20px 0;
  }
  .info {
    background-color: $bgDark3;
    color: $subFontColor;
    padding: 9px 16px 7px;
    span, a {
      color: $mainColorDark;
      cursor: pointer;
    }
  }
  .left {
    .questionnaire {
      background-color: $bgDark3;
      padding: 5px 8px;
      span {
        color: $mainColor;
        cursor: pointer;
        margin: 0 10px 0 13px
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: bold;
    font-size: map-get($fontSize,xx-large);
    margin-bottom: 10px;
    text-align: left;
  }
  .tip {
    font-size: map-get($fontSize,small);
    color: $subFontColor;
    text-align: left;
  }
  .right {
    display: flex;
    align-items: center;
    .el-button {
      display: flex;
      align-items: center;
      .icon {
        margin-right: 5px;
        .instructions {
          width: 15px;
          height: 15px;
          path {
            fill: $mainColor;
          }
        }
      }
    }
  }
}
</style>
